import { Entity, type EnemyConstruction } from "../Entity";

/** Stationary authored generator target. */
export class GeneratorEntity extends Entity {
  constructor(init: EnemyConstruction) {
    super(init);
  }

  override get isGenerator(): boolean {
    return true;
  }

  override get keepsFacingSheet(): boolean {
    return true;
  }

  protected override beginRollAnimation(): void {
    this.animOffset = this.enemyData.frameLimitNormal;
  }

  protected override resetRollAnimation(destroyed: number): number {
    this.animOffset = 0;
    return destroyed;
  }
}
